import { z } from 'zod';
import { containsEmojis } from './stringUtil';
import { defaultValidationMessages } from '../defaultValidationMessages';

export const requiredText = (max: number) =>
  z
    .string({ message: defaultValidationMessages.required })
    .trim()
    .min(1, { message: defaultValidationMessages.required })
    .max(max, { message: defaultValidationMessages.maxNumber(max) })
    .refine((val) => !containsEmojis(val), { message: defaultValidationMessages.noEmojis });

export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max, { message: defaultValidationMessages.maxNumber(max) })
    .refine((val) => !containsEmojis(val), { message: defaultValidationMessages.noEmojis })
    .optional();
